import React from 'react'

function CommunityAgreementDE() {
  return (
    <>
      <p className="heading-1">
        Vertrag über die Abtretung der Rechte an den vom Creator erstellten
        Inhalten
      </p>

      <div className="paragraph-2">
        <p>
          Skeepers ist eine einfache Aktiengesellschaft mit einem Kapital von
          11.470.723 Euro, eingetragen im Handels- und Unternehmensregister von
          Marseille unter der Nummer 879 038 990 mit Geschäftssitz in der Avenue
          Robert Schumann 18 - 20, CS 40494, in 13002 Marseille.
        </p>
        <p>
          Im vorliegenden Vertrag steht die Bezeichnung "Skeepers" für Skeepers
          und deren Filialen. Alle Begriffe, die mit einem Großbuchstaben
          beginnen, sind in den Skeepers- AGB definiert
        </p>
        <p>
          Durch die Veröffentlichung von Inhalten auf der Website erkennen Sie
          an und erklären sich ausdrücklich damit einverstanden, Skeepers unter
          den nachstehend definierten Bedingungen sämtliche Rechte, die Sie an
          den von Ihnen erstellten Inhalten besitzen, zu übertragen (gemäß den
          Skeepers-AGB bezeichnet der Begriff "Inhalte" Texte, Bilder,
          Fotografien, Zeichnungen, Avatare und ganz allgemein jede visuelle,
          textliche, akustische oder grafische Veröffentlichung des Creator, die
          die Produkte darstellt und im Rahmen der Dienstleistungen verbreitet
          wird), und ermächtigen Skeepers ausdrücklich dazu, Ihr Bild unter den
          nachstehend genannten Bedingungen zu verwenden:
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          1. Abtretung der Rechte am Inhalt
        </p>
        <p>
          Im Gegenzug zu den Rechten am erhaltenen Produkt treten Sie
          ausdrücklich und nicht ausschließlich an Skeepers die Gesamtheit der
          Rechte ab, die Sie am Inhalt halten, einschließlich des Rechts von
          Skeepers zu:
        </p>
        <ul className="paragraph-2">
          <li>
            Nutzung, Vervielfältigung Lizenzierung, Abtretung, Vertrieb, auch
            zeitweisen Fixierung, Vertrieb, in Verkehr bringen, extrahieren,
            Herunterladen, Speichern, Erfassung, Klassifizierung in einer
            Datenbank, Verbreitung an die Öffentlichkeit, Repräsentation,
            Nutzung des Inhalts in allen derzeit bekannten oder unbekannten
            Formaten und Trägern und insbesondere ohne einschränkende Wirkung
            dieser Aufzählung, im Internet, unabhängig von der generischen,
            geographischen oder domain-spezifischen Erweiterung der betroffenen
            Website und des Empfangslandes des Inhalts (insbesondere auf der
            Plattform und Website von Skeepers, seinen sozialen Netzwerken, wie
            Facebook, Twitter, Instagram, IGTV, Snapchat, auf den Websites zur
            Teilung audiovisueller Aufzeichnungen wie YouTube, Dailymotion,
            Pinterest, aber auch Weibo, WeChat und in allgemeiner Weise auf
            jedem anderen künftigen oder bestehenden Träger), in jeglicher Art
            der Verbreitung wie Kino, Antennenfernsehen, Satellit,
            Kabelnetzbetreiber und TNT, sowie über jegliches bestehende oder
            künftige Verfahren in Frankreich und im Ausland.
          </li>
          <li>
            Umfassender oder teilweiser Bearbeitung des Inhalts durch Zusatz,
            Auslassung, Anpassung, Übersetzung, Ableitung, Montage und
            Synchronisation in einer anderen, als der französischen Sprache,
            Vornahme jeglicher weltweiter, vollständiger oder teilweiser
            Extraktionen von Inhalten, insbesondere jeder zweckmäßigen Nutzung
            auf allen Trägern. Die abgetretenen Inhalte können ebenso Gegenstand
            einer Adaption und/oder einer Übersetzung sein mit dem Ziel der
            Integration in ein anderes audiovisuelles, multimediales und/oder
            digitales Werk auf allen Trägern, wie hierunter definiert sein;
          </li>
          <li>
            der vollständigen oder teilweisen Abtretung der Rechte zu den
            Bedingungen dieses Vertrages. Insbesondere kann das Recht zur
            Repräsentation und Verbreitung Ihres Inhalts auf allen Trägern und
            in allen Formaten abgetreten werden und namentlich:
            <ul className="paragraph-2">
              <li>
                im Internet (insbesondere auf der Website und/oder den sozialen
                Netzwerken seines Partners wie Facebook, Twitter, Instagram,
                IGTV, Snapchat, auf den Websites zur Veröffentlichung
                audiovisueller Aufzeichnungen wie YouTube, Dailymotion,
                Pinterest, aber auch Weibo, WeChat und, in allgemeiner Weise,
                auf jedem anderen bestehenden oder künftigen Träger), in jeder
                Art der Verbreitung wie dem Kino und Antennenfernsehen, per
                Satellit, Kabelnetzbetreiber oder TNT sowie über jegliches in
                Frankreich und im Ausland bestehende oder künftige Verfahren,
                auf der/den E-Commerce-Website(s), auf der/den der Kunde seine
                Produkte zum Verkauf anbietet, unabhängig davon, ob er der
                Herausgeber dieser Website(s) ist oder nicht) und von den
                generischen, geographischen oder domain-spezifischen Endungen
                der Website des Kunden und vom Empfangsland des Inhalts;
              </li>
              <li>
                an den physischen Verkaufsstellen (Geschäften, Kiosken) des
                Kunden, auf Messen, Fachmessen, physischen Orten für Werbung,
                Ausstellungen und allen anderen öffentlichen Veranstaltungen,
                bei denen der Kunde anwesend oder vertreten ist;
              </li>
              <li>
                intern oder zum Vorteil der Mitglieder und Mitarbeiter des
                Kunden.
              </li>
            </ul>
          </li>
        </ul>
        <p>
          Diese Abtretung gestattet Skeepers die Nutzung der beschriebenen
          Inhalte zu Zwecken der externen und internen Kommunikation sowohl
          unentgeltlich als auch werbend, werbungsbezogen, zu
          Veranstaltungszwecken, geschäftlich und gewinnbringend, insbesondere
          durch die Vermarktung und/oder die Bereitstellung von Produkten oder
          Dienstleistungen für seine Kunden, direkt oder über Vermittlung von
          Skeepers befugten Dritten.
        </p>
        <p>
          Die vorliegende Abtretung von Rechten wird ab dem Tag Ihrer Annahme
          des vorliegenden Vertrags für die gesetzliche Laufzeit der
          Schutzrechte gewährt. Die vorliegende Abtretung gilt weltweit.
        </p>
        <p>
          Hinsichtlich Ihrer Urheberpersönlichkeitsrechte, erlaubt das Recht zur
          Anpassung der Inhalte der Gesellschaft Skeepers, die Inhalte zu
          bearbeiten sowie technisch bedingte Bearbeitungen der Inhalte
          vorzunehmen, wie z. B. alle Bearbeitungen, die notwendig werden durch
          technische Beschränkungen oder um die Umsetzung der Inhalte in
          jeglicher Form und auf jeglichem Träger nach der Wahl von Skeepers zu
          ermöglichen, auf denen die Inhalte vervielfältigt und dargestellt
          werden. Sie verzichten darauf, diese Änderungen anzufechten und zudem
          eine Entschädigung oder Entlohnung jeglicher Art für diese Änderungen
          zu verlangen, wenn die Unversehrtheit Ihrer Arbeit respektiert wird.
        </p>
        <p>
          Sie erklären und gewährleisten Skeepers, dass Sie Alleininhaber der
          Gesamtheit, der zu den Bedingungen des vorliegenden Vertrags
          abgetretenen Rechte sind. Sie gewährleisten folglich, dass Sie ggf.
          von Autoren und/oder Assistenten, die im Rahmen der Umsetzung der
          Inhalte beteiligt waren und irgendwelche Rechte an den Inhalten
          geltend machen und sie nutzen könnten, alle notwendigen Rechte und
          Befugnisse erhalten haben, die es Ihnen erlauben, die Eigentumsrechte,
          die mit den Inhalten verbunden sind, zum Nutzen von Skeepers
          abzutreten und insbesondere die Rechte zur Nutzung der ggf. mit Ihren
          Inhalten verbundenen Musik.
        </p>
        <p>
          Sie erklären ebenfalls, dass die Rechte weder Gegenstand einer
          teilweisen oder vollständigen Übertragung waren, sei sie unentgeltlich
          oder entgeltlich, noch einer Nutzungslizenz jedweder Art, einer
          Verpfändung oder eines Pfandrechts für wen auch immer, einer
          Anfechtung in gleich welcher Form, mit Ausnahme der dem sozialen
          Netzwerk bewilligten Lizenz, auf den Sie den Inhalt gestellt haben.
        </p>
        <p>
          Sie gewährleisten die ungestörte Nutzung dieser Rechte, und Sie
          verpflichten sich, Skeepers bezüglich jeglicher, insbesondere
          finanzieller, Folgen schadlos zu halten, die aus jeglicher Anfechtung,
          Forderung oder Klage eines Dritten in Bezug auf die Besitzrechte am
          Inhalt entstehen könnten.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">2. Bildrechte</p>
        <p>
          Soweit Sie im Inhalt erscheinen, gestatten Sie Skeepers ausdrücklich,
          die Eigenschaften Ihrer Persönlichkeit zu nutzen (insbesondere Bild,
          persönliche Marke, persönliches Logo, Nachnamen, Vornamen und Stimme),
          um es Skeepers zu gestatten, die Rechte auszuüben, die ihr in Bezug
          auf den Inhalt in Übereinstimmung mit Punkt 1 oben zugestanden wurden.
        </p>
        <p>
          Im Gegenzug zu den Rechten am erhaltenen Produkt gestatten Sie
          Skeepers ausdrücklich:
        </p>
        <ul className="paragraph-2">
          <li>
            Erfassung, Anbringung, Vervielfältigung, Anpassung und Verbreitung
            Ihres Bildes (insbesondere einschließlich Ihres Bildes, persönlichen
            Marke, persönlichen Logos, Stimme, Namens und Vornamens) auf der
            Gesamtheit der Träger zur Aufnahme, Reproduktion und Verbreitung
            unter Nummer 1) hierunter und insbesondere im Internet auf der
            Plattform und Website von Skeepers und den sozialen Netzwerken wie
            Facebook, Twitter, Instagram, IGTV, Snapchat und den Websites zur
            Teilung audiovisueller Aufzeichnungen wie YouTube, Dailymotion,
            Pinterest, aber auch Weibo, WeChat und, im Allgemeinen auf jeglichen
            bestehenden oder zukünftigen Trägern), jegliche andere Art der
            Verbreitung wie Kino, Antennenfernsehen, Satellit,
            Kabelnetzbetreiber oder TNT und über jegliche bestehende oder
            zukünftige Art der Verbreitung in Frankreich und im Ausland,
            unabhängig von der generischen, geographischen oder
            domain-spezifischen Erweiterung der betroffenen Website und vom
            Empfangsland des Inhalts;
          </li>
          <li>
            Übergabe an den Kunden, zu dessen Nutzen der Inhalt erstellt wurde
            (insbesondere Hersteller, Händler, Händler-Websites und im
            Allgemeinen Geschäftskunden usw.) Das unter-vergebbare Recht an der
            Verwendung der Attribute Ihrer Persönlichkeit, (insbesondere Bild,
            persönliche Marke, persönliches Logo, Name, Vorname und Stimme) im
            Internet (insbesondere auf der Website und/oder den sozialen
            Netzwerken des Kunden, wie Facebook, Twitter, Instagram, IGTV,
            Snapchat, auf den Websites zur Teilung audiovisueller Aufzeichnungen
            wie YouTube, Dailymotion, Pinterest, aber auch Weibo, WeChat und im
            Allgemeinen auf jeglichem anderen bestehenden oder künftigen
            Träger), in jeder Art der Verbreitung wie Kino und
            Antennenfernsehen, Satellit, Kabelnetzbetreiber oder TNT sowie über
            jegliches bestehende oder künftige Verfahren in Frankreich und im
            Ausland, auf der/den E-Commerce-Websites(s), auf der/denen der Kunde
            seine Produkte zum Verkauf anbietet, sei er der Herausgeber dieser
            Website(s) oder nicht) und unabhängig von den generischen,
            geographischen oder domain-spezifischen Endungen der Website des
            Kunden und vom Empfangsland des Inhalts, über physische
            Verkaufsstätten (Geschäfte, Kioske) des Kunden, auf Messen,
            Fachmessen, bei Ausstellungen oder allen anderen physischen Orten
            zur Werbung und allen anderen öffentlichen Veranstaltungen, bei
            denen der Kunde zugegen oder vertreten ist, sowie intern zum Vorteil
            der Mitglieder und Angestellten des Kunden.
          </li>
        </ul>
        <p>
          Die vorliegende Genehmigung gilt weltweit und für eine Laufzeit von
          zwanzig (20) Jahren ab Datum Ihrer Annahme des vorliegenden Vertrags.
        </p>
        <p>
          Sie erklären und gewährleisten den Erhalt der schriftlichen Zustimmung
          der im Inhalt dargestellten Personen oder ihrer rechtlichen Vertreter
          zur Verwendung der Attribute ihrer Persönlichkeit (insbesondere Bild,
          Name, Stimme), sodass der Inhalt von Skeepers und seinem Kunden gemäß
          den im Vorliegenden festgelegten Bedingungen frei verwendet,
          verbreitet, vervielfältigt und genutzt werden kann. Sie verpflichten
          sich, diese Genehmigung ohne Verzögerung auf erstes Anfordern von
          Skeepers zu bestätigen. Sie verpflichten sich, Skeepers bezüglich
          jeglicher Folgen schadlos zu halten, die aus der Anfechtung, Forderung
          oder Klage eines Dritten in Bezug auf die Verwendung der Attribute
          seiner Persönlichkeit entstehen könnten.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">3. Gemeinsame Bestimmungen</p>
        <p>
          Die Abtretung Ihrer Rechte am Inhalt entsprechend Punkt 1) und der
          Genehmigung zur Nutzung Ihres Bildes gemäß Punkt 2) ist gestattet in
          Bezug auf die Nutzung, den Betrieb und die institutionelle sowie
          werbliche Promotion seiner Website durch Skeepers, seiner Plattform,
          seiner Aktivitäten sowie der institutionellen und werblichen Promotion
          seiner Produkte, Dienstleistungen und Aktivitäten des Kunden, zu
          dessen Nutzen der Inhalt erstellt wurde.
        </p>
        <p>
          Entsprechend Artikel L.122-7 des Gesetzes über das geistige Eigentum
          erkennen Sie ausdrücklich an und akzeptieren, dass die vorliegende
          Abtretung der Rechte und Genehmigung zur Verwendung Ihres Bildes
          ausschließlich im Gegenzug zum erhaltenen Produkt gestattet ist. Sie
          verzichten darauf, jegliche andere Gegenleistung, einschließlich
          finanzieller Art, zu verlangen.
        </p>
        <p>
          Für den Fall, dass Sie bei Annahme des vorliegenden Vertrags
          minderjährig (unter 18 Jahren) sein sollten, erklären Sie und
          gewährleisten Skeepers, die Erlaubnis Ihrer Eltern oder des(r)
          Inhaber(s) der elterlichen Gewalt, oder mangels deren, Ihrer
          gesetzlichen Vormundschaft zur Annahme des vorliegenden Vertrags
          erhalten zu haben. Sie verpflichten sich, diese Genehmigung ohne
          Verzögerung auf erstes Anfordern von Skeepers zu bestätigen.
        </p>
        <p>
          Im Fall eines Widerspruchs zwischen dem vorliegenden Vertrag und den
          allgemeinen Verwendungsbestimmungen der Website und der Plattform von
          Skeepers haben die Bestimmungen des vorliegenden Vertrags Vorrang.
        </p>
        <p>
          Im Fall der Annullierung einer der Klauseln des vorliegenden Vertrags
          durch ein Gericht oder jegliche andere berechtigte Behörde bleiben
          alle weiteren Klauseln des Vertrags in Kraft, es sei denn, sie hätten
          durch die Annullierung der Klausel keinen Bezug mehr oder würden nicht
          vollziehbar.
        </p>
        <p>Der vorliegende Vertrag unterliegt französischem Recht.</p>
        <p>
          Keinerlei Toleranz von Skeepers kann unabhängig von Art, Umfang, Dauer
          und Häufigkeit als rechtstiftend zu Ihrem Vorteil verstanden oder als
          Verzicht seiner Seite auf irgendeine der Bestimmungen des vorliegenden
          Vertrags interpretiert werden.
        </p>
        <p>
          Auf Grundlage ausdrücklicher Vereinbarung sind E-Mails und die auf der
          Website und Plattform von Skeepers verwendeten automatischen
          Aufzeichnungsanlagen für die Parteien verbindlich.
        </p>
      </div>
    </>
  )
}

export default CommunityAgreementDE
